import { render, staticRenderFns } from "./FamilyStatusEditor.vue?vue&type=template&id=0fb44334&scoped=true&"
import script from "./FamilyStatusEditor.vue?vue&type=script&lang=js&"
export * from "./FamilyStatusEditor.vue?vue&type=script&lang=js&"
import style0 from "./FamilyStatusEditor.vue?vue&type=style&index=0&id=0fb44334&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fb44334",
  null
  
)

export default component.exports